<template>
  <div class="loading">
    <div class="loading__mask column--central">
      <img
        :src="clinic.urls.logo"
        class="image--circle image--size-x-3 bc--secondary"
      >
      <div class="fc--white mt4">
        {{ content }}
      </div>
      <div class="loading__loader">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
</template>

<script>
import spiderman from '@/spiderman';

export default {
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      clinic: spiderman.clinic,
    };
  },
};
</script>
